/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApolloError } from '@cyren/common-lib';
import { toast } from 'react-toastify';

// QA/QC FIX: [HIGH] - TypeScript bypasses compromising type safety
// LOGIC ISSUE: File-level eslint-disable bypasses all TypeScript type checking, reducing code quality
// SOLUTION: Remove global disable and fix individual type issues:
// 1. Define proper GraphQL error interfaces
// 2. Use type assertions where necessary: (e.graphQLErrors?.[0]?.extensions as GraphQLErrorExtensions)
// 3. Create specific error detail types instead of using 'any'
// IMPACT: Runtime type errors, difficult debugging, reduced code maintainability

export function onError(e: ApolloError) {
  // QA/QC FIX: [HIGH] - TypeScript @ts-ignore bypass in critical error handling
  // LOGIC ISSUE: @ts-ignore bypasses type checking for GraphQL error structure access, hiding potential runtime errors
  // SOLUTION: Define proper types for GraphQL error extensions:
  // interface GraphQLErrorExtensions { error?: { details?: { errors?: Array<{ message: string }> } } }
  // const extensions = e.graphQLErrors?.[0]?.extensions as GraphQLErrorExtensions;
  // IMPACT: Runtime crashes from unexpected error structure, difficult error debugging
  // @ts-ignore
  const errors = e.graphQLErrors?.[0]?.extensions?.error?.details?.errors;

  // QA/QC FIX: [HIGH] - Unsafe any type bypassing error message type safety
  // LOGIC ISSUE: Using 'any' type bypasses type safety for error message extraction, can cause runtime errors
  // SOLUTION: Define proper error interface with message property:
  // interface ErrorDetail { message: string; code?: string; field?: string; }
  // const msgs = errors?.map((i: ErrorDetail) => i.message);
  // IMPACT: Runtime errors from accessing undefined properties, poor error handling reliability
  const msgs = errors?.map((i: any) => i.message);
  const msg = msgs?.join(', ');

  // QA/QC FIX: [MEDIUM] - Asynchronous error throwing creating race conditions
  // LOGIC ISSUE: setTimeout for error throwing can create timing issues and unhandled rejections
  // SOLUTION: Use proper error propagation:
  // window.dispatchEvent(new CustomEvent('apolloError', { detail: e }));
  // Or use error boundary pattern for React error handling
  // IMPACT: Unhandled promise rejections, inconsistent error reporting
  // If an apollo error fires, throw it asynchronously so that the
  // global exception handler can add it to the log
  setTimeout(() => { throw e; }, 0);

  if (msg) {
    toast.error(msg);
    return;
  }

  toast.error(e.message);
}
